export default "__VITE_ASSET__CFZM426Q__"